import _typeof from "@babel/runtime/helpers/typeof";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sainsburys-tech/bolt';
import * as Common from './Common.styles';

var HowToMeasure = function HowToMeasure(_ref) {
  var image = _ref.image,
      content = _ref.content,
      unit = _ref.unit,
      additionalSection = _ref.additionalSection,
      _ref$dataTest = _ref.dataTest,
      dataTest = _ref$dataTest === void 0 ? 'size-guide' : _ref$dataTest;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Common.Heading, null, "How to measure"), /*#__PURE__*/React.createElement(Common.SubHeading, null, "To choose the correct size for you, measure your body as follows."), image && /*#__PURE__*/React.createElement(Common.ImageWrapper, null, /*#__PURE__*/React.createElement(Image, {
    src: image.src,
    alt: image.alt,
    width: "549",
    lazy: true,
    nativeLazy: true,
    "data-test": "".concat(dataTest, "-image")
  })), additionalSection, content.map(function (_ref2, index) {
    var title = _ref2.title,
        description = _ref2.description;
    var descriptionText = description;

    if (_typeof(description) === 'object') {
      descriptionText = description[unit];
    }

    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Common.Title, null, title), /*#__PURE__*/React.createElement(Common.Description, null, descriptionText));
  }));
};

HowToMeasure.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  content: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      inch: PropTypes.string,
      cm: PropTypes.string
    })])
  })),
  unit: PropTypes.oneOf(['cm', 'inch']),
  additionalSection: PropTypes.node
};
HowToMeasure.defaultProps = {
  image: null,
  content: [],
  unit: 'cm',
  additionalSection: null
};
export default HowToMeasure;